/*
 * Title: Settings/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Settings
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import { connect } from "react-redux";
import copy from "@assets/copy.png";
import plus from "@assets/plus.png";
import check from "@assets/check.png";
import LinkTo from "@components/LinkTo";
import MobileHead from "@components/Touchpoints/MobileHead";
import ImageCropper from "@components/ImageCropper";
import Joined from "@components/Joined";
import Loader from "@components/Loader";
import Api from "@services/api";
import {
  connectedTouchpoinnts
} from "@helpers/socialAuth";
import Notification from "@services/notification-service";
import CallbackService from "@services/callback-service";

interface Props {
  navigate: any;
  new_user_flag: boolean;
  addNewUserFlag: (flag: boolean) => void;
}
type MyState = {
  image: any;
  copy: boolean;
  error_message: any;
  show: boolean;
  changes: any;
  checks: boolean;
  isFetching:boolean;
};

class Settings extends React.Component<Props | any, MyState> {
  state: MyState = {
    image: null,
    copy: false,
    error_message: "",
    show: false,
    changes: "",
    checks: false,
    isFetching:false
  };

  componentDidMount() {
    //CallbackService.fetchCreator();
    this.props.addForm({});
  }

  onChangeFile = e => {
    let form = Object.assign({}, this.props.form);
    form = {
      ...form,
      profileImage: URL.createObjectURL(e.target.files[0]),

      file: e.target.files[0],
      popup: true,
    };

    this.props.addForm(form);
    e.target.value = null;
  };
  validation = async () => {
    const filter = {filter:{where:{username:this.props.user.user.username}, limit:1}};
    const form = Object.assign({}, this.props.form);
    const data = {
      url: form.url ?? ""
    };
    this.setState({
      error_message: "",
      show: false
    });
    var validRegex =
      /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi;

    if (form.url) {
      if (!validRegex.test(form.url)) {
        this.setState({
          error_message: "Please enter valid website url",
          show: false,
        });
      } else {
        this.setState(
          {
            error_message: "",
            show: true,
            isFetching:true
          },
          async () => {
            await this.props.updateCreator(data, this.props.user.user.id);
            this.setState({isFetching:false});
            this.props.fetchCreator(filter);
          }
        );
      }
    } else {
      if (form.hasOwnProperty("url")) {
        this.setState({isFetching:true});
        await this.props.updateCreator(data, this.props.user.user.id);
        this.setState({isFetching:false});
        this.props.fetchCreator(filter);
      }
    }
  };
  addForm = (key, value) => {
    const form = Object.assign({}, this.props.form);
    form[key] = value;
    this.props.addForm(form);
  };

  updateWebsiteUrl = async () => {
    var validRegex =
      /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi;
    const programId = this.props.user?.user?.programs?.[0]?.id;
    const creatorId = this.props.user?.user?.id;
    const {form} = this.props;
    const data = {
      id:programId,
      creatorId:creatorId,
      website:form?.url
    }
    if (!validRegex.test(form.url)) {
      this.setState({
        error_message: "Please enter valid website url",
        show: false,
      });
    } else {
      this.setState({isFetching:true});
      const json = await Api.updateCreatorProgram(programId, data);
      if(json.status==200){
        Notification.success(json?.data?.message);
        CallbackService.fetchCreator();
      }
      this.setState({isFetching:false});
    }
    
  }

  render() {
    const form = Object.assign({}, this.props.form);
    const { user, loader } = this.props;
    const touchpoints = ((this.props.touchpoints || []).filter(i=>i.actions.length>0 && i.active==true) || []);
    const programUrl = `${user?.user?.username}/etw`;

    const profileImage = (user?.user?.programs?.[0]?.assets?.profileImage || "");
    const website = (user?.user?.programs?.[0]?.website || "");
    const dateTime = new Date();

    return (
      <>
        <MobileHead title={"Settings"} />
        <div id="darkscrollbar" className="bg-[#F6F2E9] lg:h-[calc(100vh-80px)] h-[calc(100vh-90px)] overflow-auto">
          <div className="container mx-auto px-[25px]">
            {/*setting screen section*/}
            <div className="py-[18px]">
              <div className="max-w-[1120px] mx-auto">
                <div className="bg-[#FBFAF6] rounded-xl p-[30px_20px]">
                  <div>
                    <h4 className="font-medium text-black text-[24px] leading-[31.2px]">
                      Encore URL
                    </h4>
                    <p className="font-normal text-[black]/70 text-[18px] leading-[21.2px] mt-[7px]">
                      Before you can share your URL, the required items below
                      must be done.
                    </p>
                  </div>
                  <div className="mt-[20px] min-w-[340px] max-w-full w-full flex items-center">
                    <div className="relative h-[40px] w-auto flex items-center">
                      {(touchpoints.length > 0) &&
                      profileImage ? (
                        <>
                          <div className="bg-white truncate max-w-full flex items-center w-full mx-auto h-full px-3 rounded-[10px] text-black">
                            <p className="truncate flex items-center w-full mx-auto h-full lg:text-[18px] text-[18px] font-normal text-black">
                              {`https://${
                                process.env.REACT_APP_MAIN_DOMAIN
                              }/${programUrl}`}
                            </p>
                            <div
                              className="flex items-center justify-center pl-2 rounded-full cursor-pointer hover:opacity-70"
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  `https://${
                                    process.env.REACT_APP_MAIN_DOMAIN
                                  }/${programUrl}`
                                );
                                this.setState({ copy: true });
                              }}
                            >
                              <div className="flex flex-col items-center group">
                                <img
                                  className="object-contain w-[18px] h-[18px]"
                                  src={copy}
                                  alt="copy"
                                />
                                <div className="absolute items-center hidden top-full group-hover:flex ">
                                  <p className="relative font-medium text-center z-10 p-2 text-[12px] rounded-lg leading-none text-black whitespace-no-wrap bg-white w-20 shadow-lg">
                                    {!this.state.copy ? "Copy" : "Copied"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="bg-white truncate max-w-full flex items-center w-full mx-auto h-full px-3 select-none pointer-events-none rounded-[10px] text-black">
                            <div className="sm:max-w-full max-w-[260px] overflow-hidden  truncate opacity-4 flex items-center mx-auto h-full lg:text-[18px] text-[18px] font-normal text-[black]/30">
                              {`https://${
                                process.env.REACT_APP_MAIN_DOMAIN
                              }/${programUrl}`}
                            </div>
                            {/* <input
                            type="email"
                            readOnly
                            placeholder={`https://${user?.user?.username.toLowerCase()}.${
                              process.env.REACT_APP_MAIN_DOMAIN
                            }`}
                            className="bg-white  w-auto mx-auto h-full px-3 rounded-[10px] lg:text-[18px] text-[18px] placeholder:font-light font-normal text-black shadow-none outline-none"
                          /> */}

                            <div className="flex items-center justify-center pl-3">
                              <img
                                className="object-contain h-[18px] w-[18px]"
                                src={copy}
                                alt="copy"
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="bg-black h-[1.2px] w-full my-[20px]" />
                  <div>
                    <div className="flex items-center justify-between">
                      <h4 className="font-medium text-black text-[24px] leading-[31.2px] tracking-[0.2px]">
                        Profile Image*
                      </h4>
                      {profileImage ? (
                        <div className="h-[19px] w-[19px] bg-[#44cd51] flex items-center justify-center rounded-full">
                          <img
                            className="h-[8px] w-[10px] object-contain"
                            src={check}
                            alt="check"
                          />
                        </div>
                      ) : (
                        <div className="h-[19px] w-[19px] border border-black rounded-full" />
                      )}
                    </div>
                    <p className="font-normal text-[black]/70 text-[18px] leading-[21.2px] mt-[7px]">
                      This is how fans will recognize you, and will be on the
                      Fan ID card.
                    </p>

                    <div className="flex justify-center items-end w-full mt-[20px]">
                      {form.preview || profileImage ? (
                        <>
                          <div className="mr-[18px]">
                            {loader ? (
                              <Loader height={30} width={30} white={false} />
                            ) : (
                              <img
                                className="h-[100px] w-[100px] rounded-full object-contain drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)]"
                                src={form.preview ?? profileImage+"?t="+dateTime}
                                alt="plus"
                              />
                            )}
                          </div>

                          <label
                            htmlFor="dropzone-file"
                            className="flex flex-col justify-center items-end mr-auto h-[22px] cursor-pointer"
                          >
                            {!loader && (
                              <p className="font-normal mb-10 text-[18px] text-[black]/70 underline">
                                Edit
                              </p>
                            )}
                            <input
                              id="dropzone-file"
                              type="file"
                              accept="image/*"
                              className="hidden"
                              onChange={this.onChangeFile}
                            />
                          </label>
                        </>
                      ) : (
                        <label
                          htmlFor="dropzone-file"
                          className="flex flex-col justify-center items-center mr-auto w-[100px] h-[100px] bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer  hover:bg-gray-100"
                        >
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <img
                              className="h-[24px] w-[24px] object-contain"
                              src={plus}
                              alt="plus"
                            />
                            <p className="font-light mt-1 text-[18px] text-black">
                              upload
                            </p>
                          </div>
                          <input
                            id="dropzone-file"
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={this.onChangeFile}
                          />
                        </label>
                      )}
                    </div>
                    {form.popup && <ImageCropper />}
                  </div>

                  <div className="bg-black h-[1.2px] w-full my-[20px]" />
                  <div>
                    <div className="flex items-center justify-between">
                      <h4 className="font-medium text-black text-[24px] leading-[31.2px] tracking-[0.2px]">
                        Touchpoints*
                      </h4>
                      <div>
                        {touchpoints.length > 0 ? (
                          <div className="h-[19px] w-[19px] bg-[#44cd51] flex items-center justify-center rounded-full">
                            <img
                              className="h-[8px] w-[10px] object-contain"
                              src={check}
                              alt="check"
                            />
                          </div>
                        ) : (
                          <div className="h-[19px] w-[19px] border border-black rounded-full" />
                        )}
                      </div>
                    </div>
                    <p className="font-normal text-[black]/70 text-[18px] leading-[21.2px] mt-[7px]">
                      This is how you interact with your fans. At least one
                      touchpoint must be added.
                    </p>

                    <LinkTo
                      to="/touchpoints"
                      className="mt-[20px] text-[#4683F5]/70 hover:opacity-100 block text-[18px] font-medium w-[240px] text-left leading-[21.2px]"
                      text="Add touchpoints >"
                    />
                  </div>
                  <div className="bg-black h-[1.2px] w-full my-[20px]" />

                  <div>
                    <div className="flex items-center justify-between">
                      <h4 className="font-medium text-black text-[24px] tracking-wider">
                        Website
                      </h4>
                      {website ? (
                        <div className="h-[19px] w-[19px] bg-[#44cd51] flex items-center justify-center rounded-full">
                          <img
                            className="h-[8px] w-[10px] object-contain"
                            src={check}
                            alt="check"
                          />
                        </div>
                      ) : (
                        <div className="h-[19px] w-[19px] border border-black rounded-full" />
                      )}

                    </div>
                    <p className="font-normal text-[black]/70 text-[18px]">
                      This will be a quick access link anyone can access from
                      your bio.
                    </p>
                  </div>
                  <div className="my-[14px] max-w-[340px] h-[40px]">
                    <input
                      onChange={e => this.addForm("url", e.target.value || "")}
                      type="text"
                      value={
                        form.hasOwnProperty("url") ? form.url : website
                      }
                      placeholder="www.encore.fans"
                      className="bg-white w-full mx-auto h-[45px] px-3 rounded-[10px] text-[18px] lg:placeholder:font-normal placeholder:font-light font-normal placeholder:text-[black]/30 text-black shadow-none outline-none"
                    />
                    <p className="font-normal text-red-500">
                      {this.state.error_message}
                    </p>
                  </div>
                  <div className="">
                  {this.state.isFetching ? (
                    <div
                      className="border-[#000] text-[#000] w-[140px]
                    tracking-[0.02em] flex items-center justify-center bg-transparent border-[1.5px] rounded-full h-[35px] font-normal text-[16px] cursor-pointer transition-all duration-700 ease-in-out"
                      >
                        <Loader height={30} width={30} white={false} creator={true} />
                      </div>
                    ) : (
                      <button
                        disabled={(form?.url || "")==""}
                        onClick={this.updateWebsiteUrl}
                        className={`${(form?.url || "")?"border-[#000] text-[#000]":"border-[#afacac] text-[#afacac]"} w-[140px]
                              tracking-[0.02em] flex items-center justify-center bg-transparent border-[1.5px] rounded-full h-[35px] font-normal text-[16px] cursor-pointer transition-all duration-700 ease-in-out`}
                      >
                        save changes
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*setting screen section*/}
        </div>
        {this.props.new_user_flag && <Joined />}
      </>
    );
  }
}

const mapStateToProps = ({ user, loader, setting, creator, QrScan, touchpoint }) => {
  return {
    form: loader.assetForm,
    user: user.user,
    new_user_flag: user.new_user_flag,
    setting: setting.data,
    loader: setting.loader,
    totalTypeform: creator.typeForm.total,
    isFetching: user.isFetching,
    totalQr:(QrScan.touchpoints || []).length,
    touchpoints:touchpoint?.data
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/LoaderRedux");
  const { actions: saction } = require("@redux/SetttingRedux");
  const { actions: uaction } = require("@redux/UserRedux");
  const { actions: acreator } = require("@redux/CreatorRedux");
  return {
    ...stateProps,
    addNewUserFlag: (flag: boolean) => {
      dispatch(uaction.addNewUserFlag(flag));
    },
    addForm: (form: Object) => dispatch(actions.addAssetForm(form)),
    fetchAssets: (creatorId, programId) => uaction.fetchCreatorAsset(dispatch, creatorId, programId),
    updateCreator: (data, id) => {
     return uaction.updateCreator(dispatch, data, id);
    },
     fetchCreator:(filter) => {
      uaction.fetchCreator(dispatch, filter);
    }
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(Settings);
